import { UseQueryOptions, useQuery } from "@tanstack/react-query"
import { APIS_KEYS } from "../../apis-keys"
import { IPropsGetCheckOutRenewal, IResponseGetCheckOutRenewal } from "./types"
import type { AxiosInstance, AxiosResponse } from "axios"
import { useApi } from "../../useApi"
import { checkOutRenewalURL } from "../../../utils/constants"
async function getCheckOutRenewal(
	{ ...rest }: IPropsGetCheckOutRenewal,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseGetCheckOutRenewal> =
			await apiPrivate.get(`${checkOutRenewalURL}`, {
				params: rest,
			})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw new Error("something went wrong")
	}
}

export function useGetCheckOutRenewal(
	data: IPropsGetCheckOutRenewal,
	options?:
		| Omit<
				UseQueryOptions<
					IResponseGetCheckOutRenewal,
					unknown,
					IResponseGetCheckOutRenewal
				>,
				"queryKey" | "queryFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	return useQuery({
		queryKey: [APIS_KEYS.CHECKOUTRENEWAL, ...Object.values(data)],
		queryFn: () => getCheckOutRenewal(data, apiPrivate),
		...options,
	})
}
